import { render, staticRenderFns } from "./VideoDownloadNotice.vue?vue&type=template&id=e2a46ef8&scoped=true&"
import script from "./VideoDownloadNotice.vue?vue&type=script&lang=js&"
export * from "./VideoDownloadNotice.vue?vue&type=script&lang=js&"
import style0 from "./VideoDownloadNotice.vue?vue&type=style&index=0&id=e2a46ef8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2a46ef8",
  null
  
)

export default component.exports